<template>
    <div class="base_template">
        <Topnav />
        <slot />
        <Footer>
            <template v-slot:faq><slot name="faq"></slot></template>
        </Footer>
        <HowItWorks v-if="!hidehelp"/>
    </div>
</template>

<script>
import Footer from '@/components/base/Footer.vue';
import Topnav from '@/components/base/Topnav.vue';
import HowItWorks from '@/components/HowItWorks.vue';

export default {
    components: {
        Topnav,
        Footer,
        HowItWorks
    },

    props: ['hidehelp']
};
</script>
